import React,{useEffect, useState} from "react";
import { connect } from "react-redux";

import { makeStyles } from "@material-ui/core/styles";
import { TextField,Select, MenuItem, IconButton, Button } from "@material-ui/core";

import {
  Phone as PhoneIcon,
  DeleteOutlineOutlined as DeleteOutlineOutlinedIcon,
  ArrowRightAltOutlined as ArrowRightAltOutlinedIcon,
} from "@material-ui/icons";
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import BackspaceIcon from '@mui/icons-material/Backspace';
import "./DialPad.css";

import CallProgressBox from "../../../../components/Boxes/CallProgressBox";

//store
import * as actions from "../../../../store/actions/actionIndex";
import { LoadJs, notify, validateDialInput } from "../../../../helpers/utility";

const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      width: "100%",
    },
  },
  deleteIcon: {
    marginTop: "8px!important",
  },
  backSpaceIcon: {
    marginTop: "2px!important",
    transform: "rotate(180deg)",
    fontSize: "45px!important",
  },
  phoneIcon: {
    marginTop: "8px!important",
  },
}));

function Dialpad(props) {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const [manualDialTriggered, setManualDialTriggered] = React.useState(false);
  const [callerId, setCallerId] = useState("")
  const [mode, setMode] = useState("numberDial")
   const maxDigits = window?.Configs?.maxDigitsAllowed ?? 15;
   const defaultSymbols = "+-()#*.,/;";
   const allowedSymbolsRaw = window?.Configs?.allowedDialSymbols || defaultSymbols;

const [callerList, setCallerList] = useState([]);
  const [value, setValue] = React.useState("");


  const handleKeypadPress = (d) => {
    if (mode !== "numberDial") return;
    setValue((prev) => prev + d);
  };
  const handleKeyboardPress = (char) => {
    if (mode !== "uniqueDial") return;
    setValue((prev) => prev + char);
  };

  const handleClear = () => setValue("");
  const handleBackspace = () => setValue((prev) => prev.slice(0, -1));

 const onInputChange = (e) => {
  const next = e.target.value;

  if (mode === "numberDial") {
    const allowedSymbols = allowedSymbolsRaw.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&'); 
    const regex = new RegExp(`[^0-9${allowedSymbols}]`, "g");
    const cleaned = next.replace(regex, "");
    const digitCount = (cleaned.match(/\d/g) || []).length;
    if (digitCount <=  maxDigits ) {
      setValue(cleaned);
    }
    return;
  }

  // For uniqueDial mode — alphanumeric only
  setValue(next.replace(/[^A-Za-z0-9_-]/g, ""));
};

const cleanNumberForAPI = (value, mode) => {
  if (mode === "numberDial") {
    // Keep only digits
    return value.replace(/\D/g, "");
  }

  if (mode === "uniqueDial") {
    // Allow only A–Z, a–z, 0–9, underscore, and hyphen
    return value.replace(/[^A-Za-z0-9_-]/g, "");
  }

  return value;
};

const onNumberKeyDown = (e) => {
  if (e.key === "Enter") {
    e.preventDefault();
    clickHandler();
    return;
  }

  if (mode !== "numberDial") return;

  const allowed =
    e.key === "Backspace" ||
    e.key === "Delete" ||
    e.key === "ArrowLeft" ||
    e.key === "ArrowRight" ||
    e.key === "Tab" ||
    e.ctrlKey ||
    e.metaKey;

  if (allowed) return;
  const allowedSymbols = allowedSymbolsRaw.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
  const regex = new RegExp(`^[0-9${allowedSymbols}]$`);

  if (!regex.test(e.key)) {
    e.preventDefault();
  }
};

  // QWERTY keyboard layout for alphanumeric dialpad
  const keyboardRows = [
    ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0", "Q", "W", "E", "R", "T", "Y", "U", "I", "O", "P", "A", "S", "D", "F", "G", "H", "J", "K", "L", "Z", "X", "C", "V", "B", "N", "M"]
  ];
  const handleClose = React.useCallback(() => {
    setOpen(false);
    setValue("")
  }, [setOpen, setValue]);

  

  const clickHandler = () => {
   if (props.agentState === "FREE") {
    const numberValue = cleanNumberForAPI(value, mode)
    const validation = validateDialInput(numberValue, mode);
    if (!validation.valid) {
      notify(validation.message, "validation-error");
      return;
    }   
        setManualDialTriggered(true); 
        if(props.facilityConf.manual_dial_lookup === "1"){
          props.onManualData(props.agentId, numberValue, "", 0)
        }
       else{
              if(mode === "uniqueDial"){
             props.onDialUniqueId(props.agentId, numberValue, "", 0)
        }
        else{
        props.onAgentDial(props.agentId, numberValue, "", 0, callerId);
              }
        setOpen(true);
        }
      } else {
        notify(
          "Dial Error - Agent is not free to make a new call",
          "dial-error"
        );
      }
    LoadJs(`${window.Configs.scriptFile_path}/bc_${props.campConf.campaign_id}.js`);
  };

  // const handlePaste = (phone) => {
  //   if (mode === "uniqueDial") {
  //     phone = phone.replace(/[^a-zA-Z0-9]/g, "");
  //     if (phone.length > 50) {
  //       alert("Maximum length for unique ID is 50 characters");
  //     } else if (phone.length === 0) {
  //       notify("Pasted content must contain letters and numbers only", "validation-error");
  //     } else {
  //       setNumber(phone);
  //     }
  //   } else {
  //   phone = phone.replace(/\D/g, "");
  //   if (phone.length > 14) {
  //     alert("Maximum length for phone number is 15");
  //   } else {
  //     setNumber(phone);
  //     }
  //   }
  // };

  if (open === true && props.error !== null && !props.loading) {
    setOpen(false);
  }
  useEffect(() => {
     const numberValue = cleanNumberForAPI(value, mode)
    if (manualDialTriggered) {
      if (props.leads && props.leads.length > 0) {
      } else {
        if(mode === "uniqueDial"){
             props.onDialUniqueId(props.agentId, numberValue, "", 0, callerId)
        }
        else
          {
        props.onAgentDial(props.agentId, numberValue, "", 0, callerId);
        }
      }
      setManualDialTriggered(false); 
    }
  }, [props.leads]);

  // HandlerCaller
const handleCallerId = (event) => {
  setCallerId(event.target.value);
};

const callerIdItems = props.campConf.caller_id?.length > 0
  ? props.campConf.caller_id.map((provider) => {
      const validIds = provider.callerids?.filter(id => id !== "0") || [];
      return [
        <MenuItem key={`${provider.provider_name}-label`} disabled style={{fontWeight: 'bold'}}>
          {provider.provider_name}
        </MenuItem>,
        ...validIds.map(id => (
          <MenuItem key={`${provider.provider_name}-${id}`} value={id}>
            {id}
          </MenuItem>
        ))
      ];
    }).flat()
  : [
    <MenuItem disabled key="no-caller-id" value="">
      No Caller ID Available
    </MenuItem>
  ];


  const handleModeChange = (event) => {
    setMode(event.target.value);
    // Clear the input when switching modes
    setValue("");
  }
  return (
    <>
      <div
        id="wrapper"
        className="position"
        style={{ display: open ? "none" : "" }}
      >
        <div className="dialpad compact position">
          {props.campConf.third_party_caller_id === "1" && props.campConf.third_party_caller_id !== null  && (
          <div className="caller select-mode" style={{ padding: "0px 5px 12px 5px" }}>
           <label style={{fontSize: "17px", paddingBottom: "10px", display:"block"}}>
            Caller Id
            </label>
        <Select
    inputProps={{ 'aria-label': 'Without label' }}
    value={callerId}
    onChange={handleCallerId}
    variant="outlined"
    displayEmpty
    renderValue={(selected) => {
      if (!selected) {
        return <span style={{ color: '#aaa' }}>Select Caller Id</span>;
      }
      return selected;
    }}
    MenuProps={{
    
  }}
  >
    <MenuItem  value="">Select Caller Id</MenuItem>
    {callerIdItems}
  </Select>

          </div>
          )}
{/* Select Mode*/}

                {props.campConf.dialing_through_cust_uniqid === "1"  && (
          <div className="select-mode" style={{paddingBottom: "20px"}}>
            <label style={{fontSize: "17px", paddingBottom: "10px", display:"block"}}>
             Dial Mode
            </label>
     <Select
         displayEmpty
          inputProps={{ 'aria-label': 'Without label' }}
          value={mode}
          onChange={handleModeChange}
          variant="outlined"
        >
          <MenuItem value={"numberDial"}>Dial with Number</MenuItem>
          <MenuItem value="uniqueDial">Dial a Unique Id</MenuItem>
        </Select>

          </div>
          )}
         <label style={{fontSize: "17px",  paddingBottom: "0px", display:"block"}}>{mode === "uniqueDial" ? "Unique Id" : "Phone Number" }</label>
        
          <>
          <div className="dials position" style={{ padding: "0px 5px" }}>
             <form className={classes.root} noValidate autoComplete="off">
              <TextField
                fullWidth
                size="small"
                variant="outlined"
                placeholder={
                  mode !== "uniqueDial" ? "8567654457" : "e.g. USER123A"
                }
                value={value}
                onChange={onInputChange}
                onKeyDown={onNumberKeyDown}
                inputMode={mode !== "uniqueDial" ? "numeric" : "text"}
                inputProps={{ maxLength: mode !== "uniqueDial" ? 50 : 50 }}
                helperText={mode !== "uniqueDial" ? `Enter digits only, up to ${maxDigits} digits.` : "Enter alphanumeric characters only"}
                InputProps={{
                  endAdornment: value && (
                    <IconButton
                      onClick={handleBackspace}
                      size="small"
                      className="text-gray-500 hover:text-black"
                    >
                      <BackspaceIcon fontSize="small" />
                    </IconButton>
                  ),
                }}
              />
               {(props.campConf.dialing_through_cust_uniqid !== "0" && props.campConf.dialing_through_cust_uniqid !== null && mode !== "uniqueDial") || props.campConf.dialing_through_cust_uniqid === "0" ?
         (
           <>
        <div style={{
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: "center",
                  gap: "8px",
                  margin: "10px auto 0"
                }}>
                {["1", "2", "3", "4", "5", "6", "7", "8", "9"].map((d) => (
                  <button
                    key={d}
                    onClick={() => handleKeypadPress(d)}
                    style={{
                        width: "110px",
                        height: "44px",
                        border: "1px solid #E0E0E0",
                        borderRadius: "10px",
                        background: "#FFFFFF",
                        boxShadow: "0 1px 2px rgba(0,0,0,0.06)",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "18px",
                        fontWeight: 600,
                        color: "#1F2937",
                        transition: "background 0.15s ease, transform 0.05s ease"
                      }}
                  >
                    {d}
                  </button>
                ))}
              </div>
              <div className="" style={{ display: "flex",
                    alignItems: "center",
                    justifyContent: "center", marginTop: "10px"}}>
                 <button
                  onClick={() => handleKeypadPress("0")}
                  style={{
                    width: "100px",
                    height: "44px",
                    border: "1px solid #E0E0E0",
                    borderRadius: "10px",
                    background: "#FFFFFF",
                    boxShadow: "0 1px 2px rgba(0,0,0,0.06)",
                    cursor: "pointer",    
                    fontSize: "16px",
                    fontWeight: 600,
                    color: "#1F2937"
                  }}
                >
                  0
                </button>
                </div>
              <div style={{  display: "flex",
                    alignItems: "center",
                    justifyContent: "center", margin: "10px 0", backgroundColor: "#f0f0f0", cursor: "pointer", padding: "10px"}}  onClick={handleClear}>
                <button
                 
                  style={{
                    fontSize: "16px",
                    color: "#1F2937",
                    display:"flex",
                    alignItems:"center",
                     border: "none",
                     cursor: "pointer",
                  }}
                >
                  <RestartAltIcon fontSize="small" />
                  <span>Clear</span>
                </button>
              </div>
             </>
         )
         : (
          <>
          {keyboardRows.map((row, rowIndex) => (
                <div key={rowIndex} style={{ display: "flex", justifyContent: "center", flexWrap: "wrap", gap: "4px", marginTop: rowIndex > 0 ? "6px" : "20px" }}>
                  {row.map((key) => (
                    <button
                      key={key}
                      className="position"
                      onClick={() => handleKeyboardPress(key)}
                      style={{
                        width: "40px",
                        height: "44px",
                        border: "1px solid #E0E0E0",
                        borderRadius: "10px",
                        background: "#FFFFFF",
                        boxShadow: "0 1px 2px rgba(0,0,0,0.06)",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "14px",
                        fontWeight: 600,
                        color: "#1F2937",
                        transition: "background 0.15s ease, transform 0.05s ease",
                        listStyle: "none"
                      }}
                      onMouseDown={(e) => {
                        e.target.style.background = "#F3F4F6";
                        e.target.style.transform = "scale(0.98)";
                      }}
                      onMouseUp={(e) => {
                        e.target.style.background = "#FFFFFF";
                        e.target.style.transform = "scale(1)";
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.background = "#FFFFFF";
                        e.target.style.transform = "scale(1)";
                      }}
                    >
                      <strong>{key}</strong>
                    </button>
                  ))}
                </div>
              ))}
            <div style={{  display: "flex",
                    alignItems: "center",
                    justifyContent: "center", margin: "10px 0", backgroundColor: "#f0f0f0", cursor: "pointer", padding: "10px"}} onClick={handleClear}>
                <button
                  onClick={handleClear}
                  style={{
                    fontSize: "16px",
                   border: "none",
                    color: "#1F2937",
                    display:"flex",
                    alignItems:"center",
                    cursor: "pointer",
                  }}
                >
                  <RestartAltIcon fontSize="small" />
                  <span>Clear</span>
                </button>
              </div>

          </>

         )
               }
          <div className="" style={{display: "flex", alignItems: "center", justifyContent: "space-between"}}>
          <Button
            variant="outlined"
            onClick={props.handleClose}
            className="flex-1 font-sans h-11"
          >
            Cancel
          </Button>
          <Button
            onClick={clickHandler}
            variant="contained"
            color="primary"
            className="flex-1 h-11 gap-2 font-sans text-white"
            style={{backgroundColor: "#0a82da", color: "#fff"}}
            startIcon={<PhoneIcon />}
          >
            Call
          </Button>
          </div>

            </form>

          </div>
          </>
        
        </div>
      </div>
      <CallProgressBox
        selectedValue={{ name: "", phone: value}}
        open={open}
        mode= {mode} 
        handleClose={handleClose}
      />
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    error: state.agentDial.error,
    loading: state.agentDial.loading,
    agentState: state.agentData.agentState,
    agentId: state.agentData.agentId,
    campConf: state.agentConfig.campConf,
    facilityConf: state.agentConfig.facilityConf,
    leads: state.manualData.leads,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
     onManualData: (agentId, phoneNo) =>
        dispatch(actions.manualData(agentId, phoneNo )),
    onAgentDial: (agentId, phone, leadId, redial, callerId) =>
      dispatch(actions.agentDial(agentId, phone, leadId, redial, callerId)),
    onDialUniqueId: (agentId, phone) =>
      dispatch(actions.agentDialUniqueId(agentId, phone))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Dialpad);
